<template>
  <v-dialog 
  :value="value" 
  @input="$emit('input')" 
  transition="fade-transition"
  width="1300px">
    <v-card>
      <v-card-title class="card-title-background">
        View Stats Analysis
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
      </v-card-title>
      <v-card-text style="overflow: hidden;margin-top: 10px;min-height: 35px;">
        <div>
          <stats-data-table isView="true" :viewHandle="handle"/>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import StatsDataTable from './DataTable';
export default {
  name: 'ViewModalDialog',
  components: {
    StatsDataTable
  },
  props: {
    value: Boolean,
    handle: String
  },
  data () {
    return {
    }
  },
  methods: {
    close() {
      this.$emit('input');
    }
  }
}
</script>
<style>
  .tiktok-stats .v-data-table__wrapper {
    border-bottom: 1px solid #e0e0e0;
  }
</style>
<style scoped>
  .card-title-background {
    background-color: #3F3FFF;
  }
  label {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// ViewModalDialog.vue?09b7be50